import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface xiaohongshuWebMsgReplyParams extends ActiomCommonParams {
    at_users?: { user_id: string; nickname: string }[]; // 被@用户ID列表
    note_id: string; // 笔记ID
    target_comment_id: string; // 目标评论ID
    content: string; // 回复内容
}

export interface ReplyResponse {
    code: number;
    success: boolean;
    msg: string;
    data: ReplyDataDetail;
}

export interface ReplyDataDetail {
    time: number;
    toast: string;
    comment: {
        id: string;
        note_id: string;
        status: number;
        content: string;
        liked: boolean;
        like_count: string;
        show_tags: string[];
        ip_location: string;
        target_comment: {
            id: string;
            user_info: {
                user_id: string;
                nickname: string;
                image: string;
            };
        };
        user_info: {
            nickname: string;
            image: string;
            user_id: string;
        };
        create_time: number;
    };
}

export type PublishAction = CommonAction<xiaohongshuWebMsgReplyParams, ReplyDataDetail | Record<string, never>>;

export const xiaohongshuWebMsgReply: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(414, "评论回复失败", {});
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };

    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };
    if (!params.note_id || !params.target_comment_id || !params.content) {
        return { code: 414, message: "参数缺失，请检查后重试！", data: {} };
    }

    const replyParams = {
        at_users: params.at_users ?? [],
        content: params.content,
        note_id: params.note_id,
        target_comment_id: params.target_comment_id,
    };

    const replyPath = "/api/sns/web/v1/comment/post";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const replyXsHeader = xsEncrypt.signHeadersPost(replyPath, recordCookie, "xhs-pc-web", replyParams);

    const res = await http.api<ReplyResponse>(
        {
            method: "post",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/comment/post",
            data: replyParams,
            headers: replyXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `评论回复${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data : {};

    return response(isSuccess ? 0 : 414, message, data);
};
